import { render, staticRenderFns } from "./Update.vue?vue&type=template&id=4fbcf0fa"
import script from "./Update.vue?vue&type=script&lang=js"
export * from "./Update.vue?vue&type=script&lang=js"
import style0 from "./Update.vue?vue&type=style&index=0&id=4fbcf0fa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports